import React, { useState } from "react";
import { auth, db } from "../../firebase/config";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useLocation } from "react-router-dom";
import { SUPPORT_EMAIL, getSupportMailto } from "../../utils/support";
import { trackDailyRollup } from "../../utils/lowCostAnalytics";

const Contact = () => {
  const location = useLocation();
  const initialIssueType =
    new URLSearchParams(location.search).get("issue") === "account_access"
      ? "account_access"
      : "support";
  const [form, setForm] = useState({
    name: "",
    email: "",
    type: initialIssueType,
    message: "",
  });

  const [submitting, setSubmitting] = useState(false);

  const updateField = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const submitContact = async (e) => {
    e.preventDefault();

    if (!form.message.trim()) {
      alert("Please add a message.");
      return;
    }

    try {
      setSubmitting(true);

      await addDoc(collection(db, "supportRequests"), {
        requestKind: "contact",
        name: form.name.trim(),
        email: form.email.trim(),
        category: form.type,
        message: form.message.trim(),
        userId: auth.currentUser?.uid || null,
        userEmail: auth.currentUser?.email || "",
        status: "open",
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
      trackDailyRollup("contact_support_submitted");

      alert("Message sent ✅");

      setForm({
        name: "",
        email: "",
        type: initialIssueType,
        message: "",
      });
    } catch (error) {
      console.error("Contact form failed:", error);
      alert(`Could not send the form. Please email ${SUPPORT_EMAIL} and we will help.`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="legal-page page-shell">
      <div className="card legal-card">
        <h1>Contact Support</h1>
        <p>
          Use this page for support questions, account issues, privacy requests,
          or safety concerns. To report a listing, profile, post, or message,
          use the Report button on that item so admins receive the right context.
        </p>
        <p>
          Prefer email? Contact MyFarmingPal support at{" "}
          <a href={getSupportMailto("MyFarmingPal support request")}>
            {SUPPORT_EMAIL}
          </a>
          .
        </p>

        <form onSubmit={submitContact} className="legal-form">
          <label className="form-label" htmlFor="contact-name">
            Name
          </label>
          <input
            id="contact-name"
            name="contactName"
            type="text"
            value={form.name}
            onChange={(e) => updateField("name", e.target.value)}
            placeholder="Your name"
          />

          <label className="form-label" htmlFor="contact-email">
            Email
          </label>
          <input
            id="contact-email"
            name="contactEmail"
            type="email"
            value={form.email}
            onChange={(e) => updateField("email", e.target.value)}
            placeholder="you@example.com"
          />

          <label className="form-label" htmlFor="contact-type">
            What is this about?
          </label>
          <select
            id="contact-type"
            name="contactType"
            value={form.type}
            onChange={(e) => updateField("type", e.target.value)}
          >
            <option value="support">Support question</option>
            <option value="account_access">Account access or recovery</option>
            <option value="safety">Safety concern</option>
            <option value="privacy">Privacy request</option>
            <option value="legal">Legal question</option>
            <option value="other">Other</option>
          </select>

          <label className="form-label" htmlFor="contact-message">
            Message
          </label>
          <textarea
            id="contact-message"
            name="contactMessage"
            value={form.message}
            onChange={(e) => updateField("message", e.target.value)}
            placeholder="Tell us what happened or what you need help with."
            rows="7"
          />

          <button className="btn-primary" type="submit" disabled={submitting}>
            {submitting ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
